import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

const SuperAdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/super-admin/login', formData);
      localStorage.setItem('superAdminToken', response.data.token);
      localStorage.setItem('superAdmin', JSON.stringify(response.data.admin));
      navigate('/super-admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f0f2f5] flex items-center justify-center p-6" data-testid="super-admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white border border-[#e5e7eb] rounded-2xl shadow-sm p-8">
          <div className="text-center mb-8">
            <img src="/logo.png" alt="SAMS" className="mx-auto h-24 w-auto object-contain mb-4" data-testid="super-admin-logo" />
            <p className="text-sm text-[#6b7280]">Super Admin Portal</p>
          </div>

          <form onSubmit={handleSubmit}>
            {error && (
              <div className="mb-4 p-3 bg-[#FEF2F2] border border-[#FCA5A5] rounded-xl text-[#EF4444] text-sm" data-testid="error-message">
                {error}
              </div>
            )}

            <div className="mb-4">
              <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                data-testid="email-input"
                className="w-full border border-[#e5e7eb] rounded-xl px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#1a1a2e]"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
              />
            </div>

            <div className="mb-6">
              <label className="block text-sm font-medium text-[#1a1a2e] mb-2" htmlFor="password">
                Password
              </label>
              <input
                type="password"
                id="password"
                data-testid="password-input"
                className="w-full border border-[#e5e7eb] rounded-sm px-3 py-2 focus:ring-2 focus:ring-[#4A7AE0]/20 focus:border-[#4A7AE0] bg-white text-[#09090B]"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
              />
            </div>

            <button
              type="submit"
              data-testid="login-button"
              disabled={loading}
              className="w-full bg-[#1E40AF] text-white hover:bg-[#1e3a8a] rounded-xl px-4 py-2 font-semibold transition-colors disabled:opacity-50"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;